import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { useState } from "react";
import "./expirationEmailButton.scss";
import { sendExpirationEmail, statusActions } from "../form/actions/PolizaActions";

var ExpirationEmailButton = function ExpirationEmailButton(props) {
  var poliza = props.poliza,
      token = props.token;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      additionalMessage = _useState4[0],
      setAdditionalMessage = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openModal = _useState6[0],
      setOpenModal = _useState6[1];

  var redirectAction = function redirectAction() {
    return window.location.href = "/admin/polizas/".concat(poliza === null || poliza === void 0 ? void 0 : poliza.id);
  };

  var handleExpirationEmailButton = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response, _response$payload;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.prev = 1;
              _context.next = 4;
              return sendExpirationEmail(poliza === null || poliza === void 0 ? void 0 : poliza.id, token, additionalMessage);

            case 4:
              response = _context.sent;

              if (!((response === null || response === void 0 ? void 0 : response.status) === statusActions.ok)) {
                _context.next = 12;
                break;
              }

              // Limpiar el mensaje
              setAdditionalMessage(""); // Cerrar el modal y redirigir

              setOpenModal(false); // Pequeño delay para que el modal se cierre antes de redirigir

              setTimeout(function () {
                redirectAction();
              }, 300);
              return _context.abrupt("return");

            case 12:
              alert((response === null || response === void 0 ? void 0 : (_response$payload = response.payload) === null || _response$payload === void 0 ? void 0 : _response$payload.message) || "Error al enviar el correo de vencimiento. Por favor, intenta de nuevo.");
              setIsLoading(false);
              return _context.abrupt("return");

            case 15:
              _context.next = 21;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](1);
              setIsLoading(false);
              console.error(_context.t0);

            case 21:
              ;

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 17]]);
    }));

    return function handleExpirationEmailButton() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "cntExpirationEmailButton"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-info",
    onClick: function onClick() {
      return setOpenModal(true);
    }
  }, "Enviar email de vencimiento")), openModal && /*#__PURE__*/React.createElement("div", {
    className: "cntExpirationEmailForm"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "modal-title",
    id: "expirationEmailModalLabel"
  }, "Enviar email de vencimiento"), /*#__PURE__*/React.createElement("div", {
    className: "form-group expiration-form-group"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "additionalMessage",
    className: "expiration-label"
  }, "Mensaje adicional (opcional)"), /*#__PURE__*/React.createElement("textarea", {
    id: "additionalMessage",
    className: "form-control expiration-textarea",
    rows: 5,
    placeholder: "Escribe un mensaje adicional que se incluir\xE1 en el correo...",
    value: additionalMessage,
    onChange: function onChange(e) {
      return setAdditionalMessage(e.target.value);
    }
  }), /*#__PURE__*/React.createElement("small", {
    className: "form-text text-muted expiration-helper-text"
  }, "Este mensaje se agregar\xE1 al final del correo de vencimiento.")), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-default expiration-cancel-btn",
    onClick: function onClick() {
      return setOpenModal(false);
    }
  }, "Cancelar"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-info expiration-send-btn",
    onClick: handleExpirationEmailButton,
    disabled: isLoading
  }, isLoading ? "Enviando..." : "Enviar correo")));
};

export default ExpirationEmailButton;